/*! Lucide icons — https://lucide.dev/
ISC License

Copyright (c) 2026 Lucide Icons and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

---

The following Lucide icons are derived from the Feather project:

airplay, alert-circle, alert-octagon, alert-triangle, aperture, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, calendar, cast, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, circle, clipboard, clock, code, columns, command, compass, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, crosshair, database, divide-circle, divide-square, dollar-sign, download, external-link, feather, frown, hash, headphones, help-circle, info, italic, key, layout, life-buoy, link-2, link, loader, lock, log-in, log-out, maximize, meh, minimize, minimize-2, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, move, music, navigation-2, navigation, octagon, pause-circle, percent, plus-circle, plus-square, plus, power, radio, rss, search, server, share, shopping-bag, sidebar, smartphone, smile, square, table-2, tablet, target, terminal, trash-2, trash, triangle, tv, type, upload, x-circle, x-octagon, x-square, x, zoom-in, zoom-out

The MIT License (MIT) (for the icons listed above)

Copyright (c) 2013-present Cole Bemis

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
(() => {
  if (window.RiritoWishlistCore) {
    return;
  }

  const BASE = '/apps/stock-notifications/wishlists';
  const STORAGE_KEY = 'ririto_wishlists';
  const routeRoot = window.Shopify?.routes?.root || '/';
  const strings = JSON.parse(document.querySelector('[data-wishlist-strings]')?.textContent || '{}');

  function t(key, values = {}) {
    return Object.entries(values).reduce(
      (text, [name, value]) => text.replaceAll(`{${name}}`, String(value)),
      strings[key] || key,
    );
  }

  function node(tag, className, text) {
    const element = document.createElement(tag);
    element.className = className || '';
    if (text !== undefined) {
      element.textContent = text;
    }
    return element;
  }

  function button(label, className, onClick) {
    const element = node('button', className, label);
    element.type = 'button';
    element.addEventListener('click', onClick);
    return element;
  }

  function setIcon(element, name, label) {
    const icons = {
      "share": "<circle cx=\"18\" cy=\"5\" r=\"3\" /> <circle cx=\"6\" cy=\"12\" r=\"3\" /> <circle cx=\"18\" cy=\"19\" r=\"3\" /> <line x1=\"8.59\" x2=\"15.42\" y1=\"13.51\" y2=\"17.49\" /> <line x1=\"15.41\" x2=\"8.59\" y1=\"6.51\" y2=\"10.49\" />",
      "publish": "<path d=\"M12 3v12\" /> <path d=\"m17 8-5-5-5 5\" /> <path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" />",
      "trash": "<path d=\"M10 11v6\" /> <path d=\"M14 11v6\" /> <path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6\" /> <path d=\"M3 6h18\" /> <path d=\"M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\" />",
      "check": "<path d=\"M20 6 9 17l-5-5\" />"
    };
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = icons[name];
    svg.classList.add('lucide', `lucide-${name === 'share' ? 'share-2' : name === 'publish' ? 'upload' : name}`);
    element.replaceChildren(svg);
    if (element.classList.contains('wishlist-share-action')) {
      element.appendChild(node('span', '', label));
    }
    element.setAttribute('aria-label', label);
    element.title = label;
  }

  function iconButton(name, label, onClick) {
    const element = button('', 'wishlist-icon-button', onClick);
    setIcon(element, name, label);
    return element;
  }

  const products = new Map();
  function getProduct(handle) {
    if (!products.has(handle)) {
      const request = fetch(`${routeRoot}products/${encodeURIComponent(handle)}.js`)
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(t('product_failed'));
          }
          return response.json();
        })
        .catch((error) => {
          products.delete(handle);
          throw error;
        });
      products.set(handle, request);
    }
    return products.get(handle);
  }

  async function postJson(url, body, options = {}) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      ...options,
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || result.ok === false) {
      throw new Error(result.errorMessage || t('request_failed'));
    }
    return result;
  }

  function loadLists() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((entry) => (
        typeof entry?.publicKey === 'string' && typeof entry?.editToken === 'string'
      )) : [];
    } catch {
      return [];
    }
  }

  function saveLists(lists) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lists));
  }

  const CLAIMS_KEY = 'ririto_wishlist_claims';
  let fallbackClaims = [];

  function loadClaims() {
    let saved = fallbackClaims;
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        const parsed = JSON.parse(window[storage].getItem(CLAIMS_KEY) || '[]');
        if (Array.isArray(parsed)) {
          saved = [...saved, ...parsed];
        }
      } catch {
        // Storage can be unavailable in private browsing.
      }
    }
    const claims = new Map();
    for (const entry of saved) {
      if (typeof entry?.publicKey !== 'string' || typeof entry?.itemId !== 'string'
        || typeof entry?.claimToken !== 'string' || !entry.claimToken
        || typeof entry?.expiresAt !== 'string' || !Number.isFinite(Date.parse(entry.expiresAt))) {
        continue;
      }
      const id = `${entry.publicKey}:${entry.itemId}`;
      const existing = claims.get(id);
      if (!existing || Date.parse(entry.expiresAt) > Date.parse(existing.expiresAt)) {
        claims.set(id, entry);
      }
    }
    return [...claims.values()].slice(-100);
  }

  function writeClaims(claims) {
    fallbackClaims = claims;
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        window[storage].setItem(CLAIMS_KEY, JSON.stringify(claims));
      } catch {
        // The in-memory copy still permits retrying on this page.
      }
    }
  }

  function getClaim(publicKey, itemId) {
    return loadClaims().find((entry) => entry.publicKey === publicKey && entry.itemId === itemId);
  }

  function rememberClaim(publicKey, itemId, claim) {
    const otherClaims = loadClaims().filter((entry) => entry.publicKey !== publicKey || entry.itemId !== itemId);
    writeClaims([...otherClaims, {
      publicKey,
      itemId,
      claimToken: claim.claimToken,
      expiresAt: claim.expiresAt,
    }].slice(-100));
  }

  function forgetClaim(publicKey, itemId) {
    writeClaims(loadClaims().filter((entry) => entry.publicKey !== publicKey || entry.itemId !== itemId));
  }

  function listUrl(entry, owner = false) {
    const query = new URLSearchParams({ key: entry.publicKey });
    if (owner) {
      query.set('owner_token', entry.editToken);
    }
    return `${routeRoot}pages/lista-cadouri?${query}`;
  }

  function thumbnail(url) {
    const media = node('span', 'wishlist-thumb');
    const placeholder = node('span', 'wishlist-thumb__placeholder', '↗');
    placeholder.setAttribute('role', 'img');
    placeholder.setAttribute('aria-label', t('no_image'));
    media.appendChild(placeholder);
    if (url) {
      const image = node('img');
      image.alt = '';
      image.width = 80;
      image.height = 80;
      image.loading = 'lazy';
      image.referrerPolicy = 'no-referrer';
      image.addEventListener('error', () => image.remove(), { once: true });
      image.src = url;
      media.appendChild(image);
    }
    return media;
  }

  function field(label, type = 'text', maxLength) {
    const wrap = node('label', 'wishlist-field');
    const input = node('input');
    input.type = type;
    if (maxLength) {
      input.maxLength = maxLength;
    }
    wrap.append(node('span', '', label), input);
    return { wrap, input };
  }

  window.RiritoWishlistCore = {
    BASE,
    routeRoot,
    t,
    node,
    button,
    setIcon,
    iconButton,
    getProduct,
    postJson,
    loadLists,
    saveLists,
    getClaim,
    rememberClaim,
    forgetClaim,
    listUrl,
    thumbnail,
    field,
  };
})();

(() => {
  if (window.RiritoWishlist) return;

  // Live-testing gate: the PDP entry only renders when ?wishlist=1 is set,
  // so we can validate on production without exposing it to all shoppers.
  try {
    if (new URLSearchParams(window.location.search).get('wishlist') !== '1') {
      document.querySelectorAll('[data-wishlist-panel]').forEach((panel) => panel.remove());
      return;
    }
  } catch {
    return;
  }

  const { BASE, loadLists, saveLists, postJson } = window.RiritoWishlistCore;

  function pageUrl(panel) {
    return panel.dataset.wishlistPage || '/pages/lista-cadouri';
  }

  function myListsUrl(panel) {
    return panel.dataset.myListsPage || '/pages/listele-mele';
  }

  function shareUrl(panel, entry) {
    return `${pageUrl(panel)}?key=${encodeURIComponent(entry.publicKey)}`;
  }

  function ownerUrl(panel, entry) {
    return `${shareUrl(panel, entry)}&owner_token=${encodeURIComponent(entry.editToken)}`;
  }

  function currentVariantId(panel) {
    // 1. Prefer the live variant from the theme event cache.
    if (panel.dataset.variantId) return panel.dataset.variantId;

    // 2. Fall back to the product form's selected variant input.
    const form = panel.closest('.product-form')?.parentElement?.querySelector('form[is="product-form"]')
      || document.querySelector('form[is="product-form"] input[name="id"]')?.form;
    const input = form?.querySelector('input[name="id"]');
    return input?.value || '';
  }

  function closeSheet() {
    document.querySelector('.wishlist-sheet')?.remove();
  }

  function showMessage(panel, text, isError) {
    const message = panel.querySelector('[data-wishlist-message]');
    if (!message) return;
    message.hidden = false;
    message.textContent = text;
    message.style.color = isError ? '#b3261e' : '#2e7d46';
  }

  function sheetShell(title, subtitle) {
    closeSheet();
    const sheet = document.createElement('div');
    sheet.className = 'wishlist-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = `
      <div class="wishlist-sheet__overlay" data-wishlist-close></div>
      <div class="wishlist-sheet__card">
        <button type="button" class="wishlist-sheet__close" data-wishlist-close aria-label="Închide">✕</button>
        <h2 class="wishlist-sheet__title"></h2>
        <p class="wishlist-sheet__subtitle"></p>
        <div class="wishlist-sheet__content"></div>
        <p class="wishlist-sheet__error" hidden></p>
      </div>`;
    sheet.querySelector('.wishlist-sheet__title').textContent = title;
    sheet.querySelector('.wishlist-sheet__subtitle').textContent = subtitle;
    sheet.querySelectorAll('[data-wishlist-close]').forEach((el) => {
      el.addEventListener('click', closeSheet);
    });
    document.body.appendChild(sheet);
    return sheet;
  }

  function sheetError(sheet, message) {
    const error = sheet.querySelector('.wishlist-sheet__error');
    error.hidden = false;
    error.textContent = message;
  }

  function myListsLink(panel, sheet) {
    const link = document.createElement('a');
    link.className = 'wishlist-sheet__mylists';
    link.href = myListsUrl(panel);
    link.textContent = 'Vezi listele mele →';
    sheet.querySelector('.wishlist-sheet__card').appendChild(link);
  }

  function openSheet(panel) {
    const variantId = currentVariantId(panel);
    if (!variantId) {
      showMessage(panel, 'Alege mai întâi o variantă.', true);
      return;
    }

    const lists = loadLists();
    const sheet = sheetShell(
      'Adaugă la lista de cadouri',
      'Oaspeții vor putea cumpăra exact această variantă, o singură dată.',
    );
    const content = sheet.querySelector('.wishlist-sheet__content');
    content.innerHTML = `
      <div class="wishlist-sheet__list"></div>
      <div class="wishlist-sheet__new">
        <input type="text" maxlength="120" placeholder="Nume listă nouă (ex. Andrei 4 ani)" aria-label="Nume listă nouă" />
        <button type="button">Creează</button>
      </div>`;

    const listBox = content.querySelector('.wishlist-sheet__list');

    if (!lists.length) {
      listBox.innerHTML = '<p class="wishlist-sheet__subtitle">Nu ai încă nicio listă. Creează prima mai jos.</p>';
    }

    for (const saved of lists) {
      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'wishlist-sheet__option';
      option.innerHTML = `<span></span><span aria-hidden="true">→</span>`;
      option.firstElementChild.textContent = saved.title;
      option.addEventListener('click', async () => {
        option.disabled = true;
        try {
          await postJson(`${BASE}/${saved.publicKey}/items`, {
            variantId,
            editToken: saved.editToken,
          });
          showAdded(panel, sheet, saved, variantId);
        } catch (err) {
          option.disabled = false;
          sheetError(sheet, err.message);
        }
      });
      listBox.appendChild(option);
    }

    const input = content.querySelector('.wishlist-sheet__new input');
    content.querySelector('.wishlist-sheet__new button').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const title = input.value.trim();
      if (!title) {
        input.focus();
        return;
      }
      button.disabled = true;
      try {
        const created = await postJson(BASE, { title });
        const entry = {
          publicKey: created.list.publicKey,
          editToken: created.editToken,
          title: created.list.title,
        };
        saveLists([...loadLists(), entry]);

        await postJson(`${BASE}/${entry.publicKey}/items`, {
          variantId,
          editToken: entry.editToken,
        });
        showAdded(panel, sheet, entry, variantId);
      } catch (err) {
        button.disabled = false;
        sheetError(sheet, err.message);
      }
    });

    myListsLink(panel, sheet);
    setTimeout(() => input.focus(), 50);
  }

  // 3. Confirmation: view the list, or publish + share it.
  function showAdded(panel, sheet, entry, variantId) {
    const content = sheet.querySelector('.wishlist-sheet__content');
    content.innerHTML = `
      <p class="wishlist-sheet__success">Adăugat în „<strong></strong>”.</p>
      <a class="wishlist-sheet__link">Vezi lista</a>
      <button type="button" class="wishlist-sheet__primary wishlist-sheet__publish">Publică și distribuie</button>`;
    content.querySelector('.wishlist-sheet__success strong').textContent = entry.title;
    content.querySelector('.wishlist-sheet__link').href = ownerUrl(panel, entry);

    showMessage(panel, `Adăugat în „${entry.title}”.`);
    panel.querySelector('[data-wishlist-open-label]').textContent = 'Adăugat ✓ Vezi lista';
    panel.dataset.wishlistLastKey = entry.publicKey;

    content.querySelector('.wishlist-sheet__publish').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      button.disabled = true;
      try {
        await postJson(`${BASE}/${entry.publicKey}/publish`, { editToken: entry.editToken });
        showShare(panel, sheet, entry);
      } catch (err) {
        button.disabled = false;
        sheetError(sheet, err.message);
      }
    });

    void variantId;
  }

  // 4. Share: copy link or native share.
  function showShare(panel, sheet, entry) {
    const url = new URL(shareUrl(panel, entry), window.location.origin).href;
    const content = sheet.querySelector('.wishlist-sheet__content');
    content.innerHTML = `
      <p class="wishlist-sheet__success">Lista „<strong></strong>” este publică. Trimite linkul invitaților:</p>
      <div class="wishlist-sheet__share-row">
        <input type="text" readonly aria-label="Link listă" />
        <button type="button">Copiază</button>
      </div>
      <button type="button" class="wishlist-sheet__primary wishlist-sheet__native">Distribuie…</button>
      <a class="wishlist-sheet__link wishlist-sheet__view">Vezi cum o văd invitații</a>`;
    content.querySelector('.wishlist-sheet__success strong').textContent = entry.title;

    const linkInput = content.querySelector('.wishlist-sheet__share-row input');
    linkInput.value = url;
    linkInput.addEventListener('focus', () => linkInput.select());

    content.querySelector('.wishlist-sheet__share-row button').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      try {
        await navigator.clipboard.writeText(url);
        button.textContent = 'Copiat ✓';
      } catch {
        linkInput.focus();
        linkInput.select();
        button.textContent = 'Copiază manual';
      }
    });

    const native = content.querySelector('.wishlist-sheet__native');
    if (!navigator.share) {
      native.hidden = true;
    } else {
      native.addEventListener('click', async () => {
        try {
          await navigator.share({ title: entry.title, url });
        } catch {
          // Dismissed — linkul rămâne disponibil pentru copiere.
        }
      });
    }

    const view = content.querySelector('.wishlist-sheet__view');
    view.href = ownerUrl(panel, entry);

    void panel;
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-wishlist-open]');
    if (!opener) return;
    const panel = opener.closest('[data-wishlist-panel]');
    if (panel) openSheet(panel);
  });

  // 5. Keep the cached variant in sync with the theme picker.
  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;
    if (!variant?.id) return;
    document.querySelectorAll('[data-wishlist-panel]').forEach((panel) => {
      panel.dataset.variantId = String(variant.id).replace(/\D/g, '') || String(variant.id);
    });
  });

  window.RiritoWishlist = { openSheet, loadLists, saveLists };
})();
